<template>
  <NewBsBox :bs="{ 'cmp.fileUpload': 'fileItemWrapper' }">
    <NewBsBox
      v-if="readonly"
      :bs="{ 'cmp.fileUpload.fileItemRO': 'wrapper' }"
      @click="handleItemClick"
    >
      <BeerIcon
        :size="14"
        :grid-size="14"
        :icon-path="ATTACHMENT_PATH"
        :bs="{ mr: 'xs' }"
        color="mute"
      />
      <NewBsBox :bs="{ 'cmp.fileUpload.fileItemRO': 'text' }">
        {{ filename }}
      </NewBsBox>
    </NewBsBox>

    <template v-else>
      <NewBsBox :bs="{'cmp.fileUpload': 'fileItem'}">
        <NewBsBox
          :data-error="error"
          :bs="{'cmp.fileUpload.fileItemRO': 'text'}"
          @click="handleItemClick"
        >
          {{ filename }}
        </NewBsBox>
        <BeerIcon
          v-if="showProgress"
          :size="10"
          :grid-size="10"
          :bs="{ 'cmp.fileUpload': 'icon' }"
          :icon-path="CROSS_PATH"
          color="mute"
          @click.stop="() => handleRemove()"
        />
        <NewBsBox
          v-else
          :bs="{ display: 'flex', alignItems: 'center'}"
        >
          <BeerIcon
            v-if="error && handleRetry"
            :size="10"
            :grid-size="36"
            :bs="{ 'cmp.fileUpload': 'icon' }"
            :icon-path="RETRY_PATH"
            color="danger"
            @click.stop="() => handleRetry()"
          />
          <BeerIcon
            :size="12"
            :grid-size="12"
            :bs="{ 'cmp.fileUpload': 'icon' }"
            :icon-path="TRASH_PATH"
            color="mute"
            @click.stop="() => handleRemove()"
          />
        </NewBsBox>
      </NewBsBox>
      <NewBsBox
        v-if="error"
        :bs="{'cmp.fileUpload': 'errorText'}"
      >
        {{ error }}
      </NewBsBox>

      <NewBsBox
        v-if="showProgress"
        :bs="{
          'cmp.fileUpload': 'progress',
          '&:before': {
            right: `${100 - uploadPercent}%`
          }
        }"
      />
    </template>
  </NewBsBox>
</template>

<script lang="tsx">
  import {
    defineComponent, computed, PropType,
  } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import {
    ATTACHMENT_PATH,
    RETRY_PATH,
    TRASH_PATH,
    CROSS_PATH,
  } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import { BeerFileItem } from './utils'

  export default defineComponent({
    name: 'BeerFileItem',
    components: {
      BeerIcon,
      NewBsBox,
    },
    props: {
      handleClick: {
        type: Function,
        default: undefined,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      uploadPercent: {
        type: Number,
        default: undefined,
      },
      filename: {
        type: String,
        default: '',
      },
      src: {
        type: String,
        default: undefined,
      },
      error: {
        type: String,
        default: undefined,
      },
      handleRemove: {
        type: Function,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        default: () => () => {},
      },
      handleRetry: {
        type: Function as PropType<() => undefined |Promise<BeerFileItem>>,
        required: false,
        default: undefined,
      },
    },
    setup(props) {
      const showProgress = computed(() => {
        if (typeof props.uploadPercent === 'undefined') {
          return false
        }
        const flag = props.uploadPercent < 100
        return flag
      })
      return {
        showProgress,
        ATTACHMENT_PATH,
        RETRY_PATH,
        TRASH_PATH,
        CROSS_PATH,
      }
    },
    methods: {
      handleItemClick(e: Event) {
        if (this.src) {
          this.handleClick?.(e)
        }
      },
    },
  })
</script>
